import { post } from './_methods';

export function addReview(formData) {
	return post('/reviews', formData);
}
